/* eslint-disable react/no-unescaped-entities */
import NewLayout from "@components/new-ui/Layout";
import React from "react";
import { CasestudyCard, CasestudyCardProps } from ".";
import { CaseStudyHerosection, CaseStudyInformation, FeatureList, Navbar, navLinks, OrganizationProfile } from "./alrannan-administrative-services";
import StatsInfo from "@components/new-ui/IndustriesSection/StatsInfo";

const casestudyCardsDetails: CasestudyCardProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/alrannan-admin-service.png",
        title: "Success Story : Improved Transparency and Increased Conversions",
        sector: "Education",
        externalLink: "/case-study/alrannan-administrative-services",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/goireland.png",
        title: "Success Story : Improved Transparency and Increased Conversions",
        sector: "Education",
        externalLink: "/case-study/goireland",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/dubai-housekeeping.png",
        title: "Gallabox transforms Dubai Housekeeping's journey to service excellence on WhatsApp",
        sector: "Service",
        externalLink: "/case-study/dubai-housekeeping",
    },
];

const Yaticorp: React.FC = () => {
    return (
        <NewLayout
            title="Yaticorp Achieves 100% Growth on WhatsApp | Gallabox Case Study"
            description="Learn how Yaticorp, an AI and IT solutions company, transformed their communication from manual chaos to automated excellence with Gallabox, achieving 100% business growth."
            canonical="https://gallabox.com/case-study/yaticorp"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/case-study/yaticorp/yaticorp-og.png" }}
        >
            <CaseStudyHerosection
                title="How Yaticorp achieved 100% business growth by transforming their communication with Gallabox"
                imageUrl={"https://assets.gallabox.com/gb-home/case-study/yaticorp/yaticorp-hero.png"}
                redirectUrl={"/case-study"}
            />
            <StatsInfo
                statsInfo={[
                    { percentage: "100%", label: "increase in business growth" },
                    { percentage: "80%", label: "growth in new customers" },
                    { percentage: "60%", label: "higher customer satisfaction" },
                ]}
            />

            <section className="max-w-7xl mx-auto  md:grid md:grid-cols-6 mt-24 mb-24">
                <div className="bg-white col-span-1">
                    <div style={{ position: "sticky", top: "100px" }}>
                        <OrganizationProfile
                            companyProfileData={[{ label: "Category", value: ["IT Services"] }]}
                            product={{
                                title: "Features Used",
                                productLink: [
                                    { link: "https://gallabox.com/whatsapp-shared-inbox", label: "Shared team inbox" },
                                    { link: "https://gallabox.com/whatsapp-flows", label: "WhatsApp Flows" },
                                    { link: "https://gallabox.com/whatsapp-chatbot", label: "WhatsApp Chatbot" },
                                    { link: "https://gallabox.com/whatsapp-drip-marketing", label: "WhatsApp Drip Marketing" },
                                    { link: "https://gallabox.com/whatsapp-broadcast", label: "WhatsApp Broadcast" },
                                    { link: "https://gallabox.com/click-to-whatsapp-ads", label: "Click-to-WhatsApp Ads" },
                                    { link: "https://gallabox.com/whatsapp-payments", label: "WhatsApp Payments" },
                                    { link: "https://gallabox.com/whatsapp-integrations", label: "Integrations" },
                                ],
                            }}
                        />
                    </div>
                </div>
                <div className=" col-span-4 md:pl-8 px-4">
                    <div className="flex flex-col gap-y-12 ">
                        <section id="About Yaticorp">
                            <p className="mt-2">
                                Founded in 2019 and based in Bangalore,{" "}
                                <a href="https://yaticorp.com" className="text-blue-500" target="_blank" rel="noreferrer">
                                    Yaticorp India Private Limited
                                </a>{" "}
                                positions itself as creators of the world's first AI card. As a young enterprise specializing in IT consulting, AI awareness, automation, and
                                technology solutions, Yaticorp serves businesses across various sectors with everything from small thin clients to large-scale virtualized
                                multi-location servers.
                            </p>
                            <p className="mt-5">Their technology-agnostic approach helps enterprises solve problems at different phases of their business journey.</p>
                        </section>

                        <section id="Challenges">
                            <CaseStudyInformation subTitle={"The challenge: Growth pains from an API tool with sub-optimal features and support "} className="mt-0" />

                            <p className="mt-2">
                                As Yatheesha K S, CEO of Yaticorp, explains, their previous WhatsApp Business API provider created more problems than it solved. "Our earlier
                                service provider did not meet our expectations. There was minimal support from their team, and the platform offered very limited features."
                            </p>
                            <p className="mt-5">
                                The impact was crippling for a tech company trying to scale. Constant delays in resolving issues, lack of flexibility in the system, and a support
                                team that was virtually absent meant Yaticorp couldn't deliver the responsive service their clients expected. For a company building AI solutions
                                and managing critical IT infrastructure, having communication tools that worked as poorly as their previous provider's was unacceptable.
                            </p>

                            <CaseStudyInformation subTitle={"From manual chaos to systematic failure"} className="mt-10" />
                            <p className="mt-2">
                                Before finding Gallabox, Yaticorp's journey through different solutions tells a story of escalating frustration. Initially, they handled everything
                                manually – lead generation, customer engagement, and even payment collection through bank transfers. "It was time-consuming, inconsistent, and
                                difficult to scale," Yatheesha recalls.
                            </p>

                            <p className="mt-5">
                                Their attempt to modernize with Tata Tele Business Services didn’t make things any better. After a month of minimal response from the support team
                                and discovering the platform's severe limitations, they knew they needed something better. The process remained inefficient and actively limited
                                their ability to grow.
                            </p>
                        </section>

                        <section id="Solutions">
                            <CaseStudyInformation subTitle={"Finding the right partner after evaluating Tata Tele Business Services, Interakt, and Wati"} className="mt-0" />
                            <p className="mt-2">
                                Yaticorp evaluated multiple providers including Tata Tele Business Services, Interakt, and Wati. Each fell short in critical areas – either lacking
                                features, offering poor support, or failing to align with their business requirements.
                            </p>
                            <p className="mt-5">
                                Gallabox stood out for several compelling reasons. "Excellent Support Team – Quick, responsive, and solution-oriented assistance whenever needed,"
                                Yatheesha emphasizes. But it wasn't just about support. The advanced automation capabilities, seamless payment integration, centralized
                                communication system, detailed analytics, cost-effectiveness, and customizable workflows all aligned perfectly with Yaticorp's needs.
                            </p>

                            <CaseStudyInformation subTitle={"Implementation: Eight objectives, one platform"} className="mt-10" />
                            <p className="mt-2">
                                Yaticorp came to Gallabox with eight specific goals: generate leads, nurture leads, streamline customer communication, retain existing customers,
                                close deals, increase cross-sell and upsell opportunities, improve team productivity, and automate customer support. They deployed every major
                                Gallabox feature:
                            </p>
                            <FeatureList
                                List={[
                                    { listItem: "Broadcast messaging keeps clients updated on new solutions and services." },
                                    { listItem: "Chatbots handle initial inquiries about IT services and AI solutions 24/7." },
                                    { listItem: "Drip marketing nurtures leads through educational content about AI and automation." },
                                    { listItem: "Flows guide prospects from initial interest to signed contracts." },
                                    { listItem: "Shared team inbox ensures technical queries never go unanswered." },
                                    { listItem: "Click-to-WhatsApp ads capture high-intent leads searching for IT solutions." },
                                    { listItem: "Payments integration eliminated the manual bank transfer hassles." },
                                    { listItem: "Integrations connected everything to their existing systems seamlessly." },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                        </section>

                        <section id="Impact">
                            <CaseStudyInformation subTitle={"The results: 100% transformation"} className="mt-0" />
                            <p className="mt-2">
                                When asked about Gallabox's impact on business growth, Yatheesha reports a 100% increase in business growth. This complete transformation shows in
                                every metric:
                            </p>

                            <FeatureList
                                List={[
                                    {
                                        listItem:
                                            "Employee productivity increased 60%: Teams now focus on delivering solutions instead of chasing payments or managing conversations manually.",
                                    },
                                    {
                                        listItem:
                                            "Customer satisfaction rates rose 60%: Quick responses and automated support mean clients get help when they need it, not when someone's available.",
                                    },
                                    {
                                        listItem:
                                            "Lead generation shot up 80%: Better automation and Click-to-WhatsApp ads capture more qualified prospects interested in AI and IT solutions.",
                                    },
                                ]}
                                className="mt-5 bg-gray-100"
                            />

                            <CaseStudyInformation subTitle={"The compound effect of proper communication"} className="mt-12" />
                            <p className="mt-2">
                                For a company helping others implement modern technology, having a state-of-the-art WhatsApp Business API tool became a bare-necessity. The 100%
                                business growth reflects how fixing this fundamental disconnect unleashed their true potential.
                            </p>
                            <p className="mt-5">
                                With payment collection automated, the finance team saves countless hours previously spent on manual reconciliation. The detailed analytics help
                                identify which AI solutions resonate most with different market segments. The customizable workflows ensure that whether someone needs a simple IT
                                consultation or a complex multi-location server setup, they receive appropriate guidance throughout their journey.
                            </p>
                            <p className="mt-5">
                                As Yaticorp continues developing innovative solutions like their AI card and expanding their IT infrastructure services, Gallabox provides the
                                communication backbone needed for sustainable growth.
                            </p>
                        </section>
                    </div>
                </div>
                <div>
                    <div style={{ position: "sticky", top: "100px", minHeight: "510px" }} className="hidden md:block">
                        <Navbar links={navLinks} />
                    </div>
                </div>
            </section>
            <div className="max-w-6xl mx-auto">
                <section>
                    <h3 className="text-gray-900 mb-10 mt-5 text-left ml-4">Check out other customer stories</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto gap-10 mb-20">
                        {casestudyCardsDetails?.map((data, index) => (
                            <CasestudyCard key={index} {...data} />
                        ))}
                    </div>
                </section>
            </div>
        </NewLayout>
    );
};

export default Yaticorp;
